import { Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  ProfileService,
  NotificationService,
  BrowserStorageKeys,
  NotificationKeys,
  ResponseStatus,
  UserTypes,
  StorageKeys,
  URLS,
} from "@core";
import { AccountType } from "src/app/core/config/profile-menu.config";
import { StorageService } from "src/app/core/services/storage/storage.service";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.less"],
  standalone: false,
})
export class UserProfileComponent implements OnInit {
  profileForm!: FormGroup;
  loading: boolean = false;
  isLoading: boolean = false;
  showForm: boolean = false;
  // renderInstitution : boolean = false
  renderNames: boolean = false;
  disableField: boolean = false;
  screenWidth: number = 0;
  userDetails: any;
  user = JSON.parse(localStorage.getItem(BrowserStorageKeys.token)!);
  renderInstitution: boolean = this.user?.type === UserTypes.VERIFIER;

  urls = URLS;

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.updateScreenSize();
  }

  private updateScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private notify: NotificationService,
    private router: Router,
    private storageSrv: StorageService,
  ) {}

  ngOnInit(): void {
    this.updateScreenSize();
    this.buildProfileForm();
    this.getUserInformation();
  }

  buildProfileForm() {
    this.profileForm = this.fb.group({
      name: [null],
      firstname: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(`^[-_a-zA-Z0-9]{1,25}$`),
        ]),
      ],
      surname: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(`^[-_a-zA-Z0-9]{1,25}$`),
        ]),
      ],
      middlename: [null],
      phone: [null],
      email: [null, [Validators.required]],
    });
  }

  checkAccountType(account: any) {
    if (account?.type == AccountType.VERIFIER) {
      this.renderInstitution = true;
      this.renderNames = false;
    }

    if (account?.type == AccountType.USER) {
      this.renderInstitution = false;
      this.renderNames = true;
    }
  }

  checkIfIdentityVerified(data: any) {
    const additional_detail = data?.additional_detail;
    const identity_verified = data?.additional_detail?.identity_verified;

    if (additional_detail !== null && identity_verified) {
      this.disableField = true;
      return;
    }

    this.disableField = false;
  }

  getUserInformation() {
    this.isLoading = true;
    this.profileService
      .getUser()
      .then(async (res: any) => {
        if (res?.status == ResponseStatus.FAILED) {
          this.showForm = false;
          this.notify.error("", res?.message, NotificationKeys.PROFILE);
          return;
        }
        this.isLoading = false;
        this.userDetails = res?.data;
        await this.profileForm.patchValue({
          name: res?.data?.name,
          email: res?.data?.email,
          firstname: res?.data?.firstname,
          surname: res?.data?.surname,
          phone: res?.data?.phone,
          middlename: res?.data?.middlename,
        });

        this.checkAccountType(res?.data);
        this.checkIfIdentityVerified(res?.data);
        // this.showForm = true;
      })
      .catch((err: any) => {
        this.isLoading = false;
        this.showForm = false;
        console.warn(err);
      });
  }

  updateUser() {
    let retrievedUser = this.storageSrv.getLocalStorageItem(StorageKeys.TOKEN);
    retrievedUser.surname = this.profileForm.controls.surname.value;
    retrievedUser.firstname = this.profileForm.controls.firstname.value;
    retrievedUser.middlename = this.profileForm.controls.middlename.value;
    this.storageSrv.setLocalStorageItem(StorageKeys.TOKEN, retrievedUser);
  }

  displayForm() {
    this.showForm = true;
  }

  submitForm(): void {
    this.loading = true;
    if (!this.profileForm.valid) {
      this.profileForm.controls.firstname.markAsDirty();
      this.profileForm.controls.surname.markAsDirty();
      this.profileForm.controls.email.markAsDirty();
      this.profileForm.controls.phone.markAsDirty();
      return;
    }
    this.profileService
      .updateUser(this.profileForm.value)
      .then((res: any) => {
        this.loading = false;

        if (res?.status === ResponseStatus.FAILED) {
          this.notify.info("", res?.message);
          return;
        }

        this.updateUser();
        this.notify.success("", res?.message);
        this.router.navigate(["/"]);
      })
      .catch((err) => {
        this.loading = false;
        console.warn(err);
      });
  }

  hideEditForm() {
    this.showForm = false;
  }
}
